module.exports = __webpack_public_path__ + "img/8-Tuk_Tuk.b7af183.png";